import React from 'react';
import cx from 'classnames';
import * as Actions from '../../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Slider } from 'antd';
import MobileDetect from 'mobile-detect';
import MediaQuery from 'react-responsive';

const md = new MobileDetect(window.navigator.userAgent);
const isMobile = !!md.mobile();

class ControlSizeOrBikeCount extends React.Component {
  state = {
    bikeCount: this.props.parameters.count,
    width: this.props.parameters.width,
    length: this.props.parameters.length
  };

  minBikes = 2;
  maxBikes = 200;
  minWidth = 12;
  maxWidth = 100;
  minLength = 12;
  maxLength = 100;

  listenForExternalParameterUpdates = (nextProps) => {
    if (
      this.props.parameters.width !== nextProps.parameters.width &&
      nextProps.parameters.width !== this.state.width
    ) {
      this.setState({ width: nextProps.parameters.width });
    }
    if (
      this.props.parameters.length !== nextProps.parameters.length &&
      nextProps.parameters.length !== this.state.length
    ) {
      this.setState({ length: nextProps.parameters.length });
    }
  };

  componentWillReceiveProps(nextProps) {
    this.listenForExternalParameterUpdates(nextProps);
  }

  handleBikeCountChange = (e) => {
    let value = isNaN(e) ? e.target.value : e;
    value = Math.min(value, this.maxBikes);
    this.setState({ bikeCount: value ? Math.floor(value) : '' });
  };

  handleBikeCountSubmit = (e) => {
    this.props.actions.parameterBikeCount(this.state.bikeCount);
  };

  handleWidthChange = (e) => {
    let value = isNaN(e) ? e.target.value : e;

    value = Math.min(value, this.maxWidth);
    this.setState({ width: value ? Math.floor(value) : '' });
  };

  handleLengthChange = (e) => {
    let value = isNaN(e) ? e.target.value : e;
    value = Math.min(value, this.maxBikes);
    this.setState({ length: value ? Math.floor(value) : '' });
  };

  get validDimensions() {
    const { width, length } = this.state;
    return width !== '' && length !== '';
  }

  handleDimensionSubmit = () => {
    const { width, length } = this.state;
    if (this.validDimensions) {
      this.props.actions.parameterDimensions(width, length);
    }
  };

  handleStep = () => {
    // if (this.props.step !== 0) {
    this.props.handleStepSet(0, false, false);
    // }
  };

  dimensions = () => {
    const {
      minWidth,
      maxWidth,
      minLength,
      maxLength,
      maxBikes,
      minBikes,
      validDimensions
    } = this;
    const { bikeCount, width, length } = this.state;
    const {
      parameters: { uxPath }
    } = this.props;
    const countActive = uxPath === 'bikes';

    return (
      <div
        className={cx({
          'card-content': true,
          active: !countActive
        })}
        style={{ alignItems: 'center' }}
      >
        <div className='input-with-submit-wrapper'>
          <div
            className={cx({
              'input-with-submit': true,
              active: !countActive
            })}
          >
            <input
              max={isMobile ? 30 : maxWidth}
              placeholder='width (ft)'
              type='number'
              onChange={this.handleWidthChange}
              value={width}
              onBlur={this.handleDimensionSubmit}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  this.handleDimensionSubmit();
                }
              }}
            />
            <MediaQuery minDeviceWidth={650}>
              <div className='slider-container'>
                <Slider
                  value={width || 0}
                  max={maxWidth}
                  min={minWidth}
                  tooltipVisible={false}
                  step={0.1}
                  onChange={this.handleWidthChange}
                  onAfterChange={this.handleDimensionSubmit}
                />
              </div>
            </MediaQuery>
            <div className='input-title'>Width (ft)</div>
          </div>

          <div
            className={cx({
              'input-with-submit': true,
              active: !countActive
            })}
          >
            <input
              max={isMobile ? 30 : maxLength}
              placeholder='length (ft)'
              type='number'
              value={length}
              onChange={this.handleLengthChange}
              onBlur={this.handleDimensionSubmit}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  this.handleDimensionSubmit();
                }
              }}
            />
            <MediaQuery minDeviceWidth={650}>
              <div className='slider-container'>
                <Slider
                  value={length || 0}
                  max={maxLength}
                  min={minLength}
                  step={0.1}
                  tooltipVisible={false}
                  onChange={this.handleLengthChange}
                  onAfterChange={this.handleDimensionSubmit}
                />
              </div>
            </MediaQuery>
            <div className='input-title'>Length (ft)</div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      minWidth,
      maxWidth,
      minLength,
      maxLength,
      maxBikes,
      minBikes,
      validDimensions
    } = this;
    const { bikeCount, width, length } = this.state;
    const {
      parameters: { uxPath }
    } = this.props;
    const countActive = uxPath === 'bikes';
    return (
      <div
        className='card-container'
        style={{ alignItems: 'center', marginBottom: isMobile ? null : '0px' }}
        onClick={this.handleStep}
      >
        {isMobile && (
          <div className='card-item control-size-count'>
            <header
              className={cx({
                // split: isMobile,
                // right: true,
                inactive: countActive
              })}
              onClick={() => {
                if (isMobile) {
                  // this.props.actions.switchUXPath('dimensions');
                }
              }}
            >
              Room Size
            </header>

            {this.dimensions()}

            {/* <div className='explainer-text'>
              {countActive || !isMobile
                ? 'Use this tool if you know how many bikes you are required to park.'
                : 'Use this tool if you know how many square feet you have to work with.'}
            </div> */}
          </div>
        )}

        {/* {!isMobile && <div className='size-count-or'>or</div>} */}
        {!isMobile && (
          <div className='card-item control-size-count'>
            <header className={cx({ inactive: countActive })}>Room Size</header>
            {this.dimensions()}
            {/* <div className='explainer-text'>
              Use this tool if you know how many square feet you have to work
              with.
            </div> */}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    parameters: state.parameters
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ControlSizeOrBikeCount);



// WEBPACK FOOTER //
// ./src/components/Controls/ControlSizeOrBikeCount/index.js